module.exports = __webpack_public_path__ + "img/main_banner_03.25849a6.jpg";